export default __webpack_public_path__ + "static/media/abrigo.25c22af1.png";